import axios from "axios";
import React, { useEffect, useState } from "react";
import CardImage from "../../assets/cardimg.png";
import { BASEURL } from "../../utils/utils";
import "./lists.css";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";

const Card = ({ project }) => {
  const navigate = useNavigate();

  return (
    <div className=" shadow-lg w-[200px] p-3 my-4 mx-2  ">
      <img
        src={BASEURL + "/images/" + project.imageUrl}
        className="h-40 w-full object-cover"
        alt=""
      />
      <p className="font-semibold mt-3">{project?.name}</p>
      <p className="text-gray-700">{project?.mintTime.substring(0, 10)}</p>
      <button
        onClick={() => navigate("/details/" + project._id)}
        className="bg-[color:var(--purple-color)] px-4 py-2 text-[16px]  text-white mt-1 rounded-xl"
      >
        View
      </button>
    </div>
  );
};

const ProjectsList = () => {
  const [allProjects, setAllProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFetchAllProjects = async () => {
    setIsLoading(true);
    axios
      .get(BASEURL + "/project/all")
      .then((res) => {
        setAllProjects(res.data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    handleFetchAllProjects();
  }, []);

  return (
    <div>
      <div className="list-header flex items-center justify-center text-white p-14">
        <p className="text-3xl">Explore</p>
      </div>
      <div className="m-auto max-w-screen-xl flex flex-wrap justify-center px-4 sm:px-24">
        {isLoading ? (
          <Loader />
        ) : (
          allProjects &&
          allProjects.map((project) => <Card project={project} />)
        )}
      </div>
    </div>
  );
};

export default ProjectsList;
